import type { badgeVariants } from '@/components/ui/badge';
import type { VariantProps } from 'class-variance-authority';
import type { KnowledgeReference } from '../../../types';

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

export const getSeverityVariant = (severity: string | undefined): BadgeVariant => {
  switch (severity?.toLowerCase()) {
    case 'critical':
      return 'destructive';
    case 'high':
      return 'warning';
    case 'medium':
      return 'info';
    case 'low':
      return 'success';
    default:
      return 'info';
  }
};

export const getCountermeasureTypeVariant = (type: string | undefined): BadgeVariant => {
  switch (type?.toLowerCase()) {
    case 'prevention':
      return 'default';
    case 'detection':
      return 'secondary';
    case 'mitigation':
      return 'info';
    default:
      return 'info';
  }
};

export const getPriorityVariant = (priority: number | undefined): BadgeVariant => {
  if (priority === 1) return 'destructive';
  if (priority === 2) return 'warning';
  return 'secondary';
};

export const getKnowledgeReferenceTitle = (ref: KnowledgeReference): string => (
  ref.fileName || ref.title || ref.documentId
);

export const getKnowledgeReferencePath = (ref: KnowledgeReference): string => (
  `/documents/${encodeURIComponent(ref.documentId)}`
);

export const formatKnowledgeReferenceSnippet = (snippet?: string): string => (
  (snippet || '').replace(/<\/?(?:em|mark)\b[^>]*>/gi, '')
);

/** Cells that hold a whole sentence: they wrap rather than truncate. */
export const LONG_TEXT_CELL = 'revy-cjk max-w-[260px] whitespace-normal text-sm leading-[1.6]';

export const SCORE_CELL = 'revy-figure text-sm font-bold';
